import React from "react";
import {CreateLinkContainer} from "../../components/containers/CreateLinkContainer";

export function CreateLink({ history }) {
  return (
    <CreateLinkContainer />
  );
}
